<div class="chart-container flex-column w-100">
  <ng-container *ngIf="!loading; else loadingTemplate">
    <ng-container *ngIf="data?.length; else empty">
      <div class="chart">
        <ng-container [ngSwitch]="chart.showAs">
          <!-- Pie -->
          <ng-container *ngSwitchCase="chartShowModes.PieChart">
            <ngx-charts-pie-chart
              [results]="data"
              [legend]="false"
              [tooltipDisabled]="true"
              class="d-flex"
              [scheme]="chartColorScheme"
              legendTitle=""
            >
            </ngx-charts-pie-chart>
          </ng-container>

          <!-- Vertical bar -->
          <ng-container *ngSwitchCase="chartShowModes.VerticalBar">
            <ngx-charts-bar-vertical
              class="d-flex"
              [results]="data"
              [legend]="false"
              [scheme]="chartColorScheme"
              [xAxis]="false"
              [showGridLines]="false"
              [showXAxisLabel]="false"
              [tooltipDisabled]="true"
            ></ngx-charts-bar-vertical>
          </ng-container>

          <!-- Horizontal bar -->
          <ng-container *ngSwitchCase="chartShowModes.HorizontalBar">
            <ngx-charts-bar-horizontal
              [results]="data"
              [legend]="false"
              class="d-flex"
              [scheme]="chartColorScheme"
              [tooltipDisabled]="true"
              [xAxis]="false"
              [showXAxisLabel]="false"
            ></ngx-charts-bar-horizontal>
          </ng-container>

          <!-- Label -->
          <p class="default-paragraph chart-thumbnail-xlabel">{{ xLabel }}</p>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="loading">loading...</div>
</ng-template>

<ng-template #empty>
  <div class="empty">
    <i class="empty-icon"></i>
    <span i18n>No data to display</span>
  </div>
</ng-template>
